// Runtime deployment config injected at startup by `AppSettingsGetter` (see
// `./AppSettingsGetter` in a follow-up commit). Kept as module-scoped state
// rather than a React context so non-React code paths (api client base URL,
// SSO client wiring) can read it too.

export interface EnvConfig {
  stage: string;
  url: string;
  label: string;
}

export interface AppSettings {
  clientShortName: string;
  appStage: string;
  defaultLocale: string;
  insightsApiBaseUrl: string;
  ssoApiBaseUrl: string;
  envs: EnvConfig[];
}

let _settings: AppSettings = {
  clientShortName: "",
  appStage: "",
  defaultLocale: "",
  insightsApiBaseUrl: "",
  ssoApiBaseUrl: "",
  envs: [],
};

export const setConfigSettings = (configsSettings: AppSettings) => {
  _settings = configsSettings;
};

export const getConfigSettings = () => {
  return _settings;
};
